export const selectedGoal = {
  available: [
    {
      id: 7117,
      status: 'available',
      assignedFrom: null,
      timesCompleted: null,
      createdAt: '2020-10-13T20:09:31.402Z',
      updatedAt: '2020-10-13T20:09:31.402Z',
      userId: 173,
      patientGoalId: 77,
      createdBy: null,
      updatedBy: null,
      reminderId: null,
      patientGoal: {
        id: 77,
        title: '4-time meal in a day',
        description: 'Eat 4 time in a day',
        duration: 'Monthly',
        type: 'goal',
        completionButton: null,
        completionPage: null,
        completionEvent: null,
        repeat: null,
        goalCategory: {
          id: 8,
          icon: '5e066e9cd67627008493d394',
        },
      },
    },
  ],
};

export const singleGoalData = [
  {
    id: 8,
    title: 'Nutrition',
    backgroundColor: '#9acd32',
    backgroundImage: null,
    icon: '5e066e9cd67627008493d394',
    createdAt: '2019-12-28T07:37:50.841Z',
    updatedAt: '2020-12-18T11:39:02.317Z',
    createdBy: null,
    updatedBy: 1,
  },
];
export const createGoal = {
  confidenceLevel: 'low',
  goalCategory: 'Nutrition',
  title: 'Test',
  duration: 'Weekly',
  type: 'goal',
  description: 'Test',
  goalCategoryId: 8,
  createdFromPatient: true,
  createdBy: 173,
  updatedBy: 173,
  id: 91,
};
export const patientGoalXrefAll = {
  complete: [
    {
      id: 7115,
      status: 'complete',
      assignedFrom: null,
      timesCompleted: null,
      createdAt: '2020-10-13T20:06:41.847Z',
      updatedAt: '2020-10-13T20:07:48.225Z',
      userId: 173,
      patientGoalId: 78,
      createdBy: null,
      updatedBy: null,
      reminderId: null,
      patientGoal: {
        id: 78,
        title: 'Walking goal',
        description: 'More than 5000 steps per day',
        duration: 'Daily',
        type: 'goal',
        completionButton: null,
        completionPage: null,
        completionEvent: null,
        repeat: null,
        goalCategory: {
          id: 10,
          icon: '5e066e9cd67627008493d38e',
        },
      },
    },
  ],
  incomplete: [
    {
      id: 4596,
      status: 'expired',
      assignedFrom: 'recommendation',
      timesCompleted: 0,
      createdAt: '2020-08-27T18:13:11.538Z',
      updatedAt: '2020-11-12T13:01:22.974Z',
      userId: 173,
      patientGoalId: 17,
      createdBy: null,
      updatedBy: 173,
      reminderId: null,
      patientGoal: {
        id: 17,
        title: 'Log my food today',
        description: 'I will log my food intake today. Once logged, I will note my challenges as well as my successes. ',
        duration: 'Daily',
        type: 'goal',
        completionButton: "I've noted my challenges and successes",
        completionPage: null,
        completionEvent: null,
        repeat: null,
        goalCategory: {
          id: 12,
          icon: '5e066e9cd67627008493d398',
        },
      },
    },
  ],
  active: {
    rows: [
      {
        id: 80,
        xrefId: 7121,
        title: 'Fitness',
        type: 'goal',
        description: 'visit fitness trainings',
        icon: '5e066e9cd67627008493d38e',
        completionPage: null,
        completionButton: null,
        completionEvent: null,
        duration: 'Weekly',
        isSystemGoal: false,
        updatedAt: '2020-11-22T16:01:28.436Z',
        percent: null,
      },
    ],
    count: 1,
  },
};

export const chooseGoal = [
  {
    id: 8,
    title: 'Nutrition',
    backgroundColor: 'yellowgreen',
    backgroundImage: null,
    icon: '5e066e9cd67627008493d394',
    createdAt: '2019-12-28T07:37:50.841Z',
    updatedAt: '2019-12-28T07:37:50.841Z',
    createdBy: null,
    updatedBy: null,
    patient_goals: [
      {
        id: 77,
        patient_goals_xrefs: [
          {
            id: 7117,
          },
        ],
      },
    ],
  },
];
